import React, { Suspense, lazy } from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';

const Dashboard = lazy(() => import('./pages/Dashboard'));
const Vectorizer = lazy(() => import('./pages/Vectorizer'));
const FaviconCreator = lazy(() => import('./pages/FaviconCreator'));
const QRStudio = lazy(() => import('./pages/QRStudio'));

const RouteFallback = () => (
  <div className="min-h-[45vh] flex items-center justify-center" role="status" aria-live="polite">
    <div className="text-center">
      <div className="w-10 h-10 mx-auto rounded-full border-4 border-slate-200 border-t-indigo-600 animate-spin" />
      <p className="mt-3 text-sm font-medium text-slate-600">Opening tool…</p>
    </div>
  </div>
);

function App() {
  return (
    <HashRouter>
      <Layout>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/vectorizer" element={<Vectorizer />} />
            <Route path="/favicon" element={<FaviconCreator />} />
            <Route path="/qr" element={<QRStudio />} />
          </Routes>
        </Suspense>
      </Layout>
    </HashRouter>
  );
}

export default App;